import React, { Component, useEffect } from "react";
import { Row, Col, Skeleton, Card, Button, message, Divider, Icon, Select } from "antd";
import UserActivitiesCard from "./parts/EA_And_LSP/UserActivityCard";
import Activity_card from "./parts/EA_And_LSP/ActivityCard";
import EaDashboardChart from "./parts/EA_And_LSP/EaDashboardCharts";
import EaProfileFilter from "./parts/EA_And_LSP/EaProfileFilter";
import axios from "axios";
import F from "../../Functions";
import moment from "moment";
import EaDateFilter from "./parts/EA_And_LSP/DateFilter";
import filter from "../../assets/icons/dashboard/filter.svg";
import { COMBINED_COMPLETED_RAC_COUNT, CUSTOMER_UPLOAD_LIVE_STAT_MONTHLY, CUSTOMER_UPLOAD_LIVE_STAT_TOTAL, GET_BAD_PHONE_NUMBER_COUNT, GET_EA_ACTIVE_CALLS, GET_EA_AGENCY_STATS, GET_EA_STATS, GET_LIVE_APPOINTMENT, GET_LSP_STATS, GET_THREE_CARD_DATA } from "../../utils/Api_enums";
import DownloadModal from "./DownloadModal";
import { useBoundStore } from "../../store/useBoundStore";
import './EaDashboard.css';
import { ALL, FOLLOWUP, PROSPECT, REVIEW } from "../../utils/Constants";

const today = new Date();
const DASH_STATS_START_DATE = "2010-01-01";
const DASH_STATS_END_DATE = "2050-01-01";

class EaDashboard extends Component {
  constructor(props) {
    super(props);
    // Default values
    //commented due to new date picker implementation
    // const defaultStartDate = "2010-01-01";
    // const defaultEndDate = "2050-01-01";

    const { start_date: defaultStartDate, end_date: defaultEndDate } = this.getDefaultDateRange();
    let start_date = defaultStartDate;
    let end_date = defaultEndDate;

    const defaultPeriod = "all_bfiles";
    const isAllBfiles = useBoundStore.getState().AMDashboardFilter.isAllBfiles !== false;

    //commented due to new date picker implementation
    // let start_date = moment(defaultStartDate).format("YYYY-MM-DD");
    // let end_date = moment(defaultEndDate).format("YYYY-MM-DD");

    let period = defaultPeriod;
    // Only reuse dateObj when the user explicitly selected a date range.
    // GlobalDashboard also writes dateObj, which must not leak into EA after switch-user.
    const myDateObj = localStorage.getItem("dateObj");
    if (myDateObj && !isAllBfiles) {
      try {
        const parsedDateObj = JSON.parse(myDateObj);
        start_date = moment((parsedDateObj.start_date)).format(
          "YYYY-MM-DD"
        );
        end_date = moment((parsedDateObj.end_date)).format(
          "YYYY-MM-DD"
        );
        period = parsedDateObj.period;
      } catch (error) {
        console.error("Error parsing dateObj from localStorage:", error);
      }
    } else if (isAllBfiles && myDateObj) {
      localStorage.removeItem("dateObj");
      localStorage.removeItem("dateObjRecentExtRaC");
    }

    this.state = {
      isAgencyReady: false,
      collapsed: this.props.collapsed,
      isAllBfiles,
      unseenNotifications: useBoundStore.getState().notificationUI.unseenNotifications,
      loadingChart: true,
      loadingStats: true,
      loading: true,
      dashboard: {
        lsp: [],
        vo_stats: {
          FollowUp: {},
          Prospect: {},
        },
        stats: {},
        card_data: {},
      },
      period: period,
      start_date: start_date,
      end_date: end_date,
      associations: [],
      user: this.props.auth.user,
      vonboard: 0,
      is_lead: 0,
      is_opportunity: 0,
      show_lead_card_appointment_details: 0,
      review: 0,
      user_t: localStorage.getItem('user_t') || "",      // use to manage the drop down filter of agency stats
      filter_lsp: localStorage.getItem('filter_lsp') || "", //use to manage the  agency stats or my stats filter
      internalFilterChange: false,
      has_rs: false,
      agency_id: null,
      agency: {},
      bfiles_counts: {
        leads: 0,
        opportunity: 0,
        review: 0,
      },
      badPhoneNumber: 0,
      // has_efs: false,
      showdownloadModal: false,
      colSpan: 8
    };
  }



  //commented old dp
  // componentDidMount = () => {
  //   let user_id = this.state.user.id;
  //   let userById = useBoundStore.getState().userById;

  //   if (!userById) {
  //     axios.get("/api/users/" + user_id).then((res) => {
  //       // let agency_id = user_id;
  //       let agency_id = res.data.user_agency_assoc[0].agency_id;

  //       axios.get("/api/agencies/" + agency_id).then((res) => {
  //         const activeCards = [
  //           res.data.review === 1,
  //           // res.data.is_lead === 1,
  //           res.data.show_lead_card_appointment_details == 1,
  //           res.data.is_opportunity === 1,
  //         ].filter(Boolean).length;
  //         this.setState(
  //           {
  //             vonboard: res.data.vonboard,
  //             is_lead: res.data.is_lead,
  //             is_opportunity: res.data.is_opportunity,
  //             show_lead_card_appointment_details: res.data.show_lead_card_appointment_details,
  //             review: res.data.review,
  //             active: res.data.active,
  //             agency_id,
  //             agency: res.data,
  //             colSpan: activeCards > 0 ? Math.floor(24 / activeCards) : 24
  //           }, () => {
  //             setTimeout(async () => {
  //               await this.call_appointment_count();
  //               await this.loadCardData();
  //               await this.loadStats();
  //             }, 1000);
  //           }
  //         );
  //       });
  //     });
  //   } else {
  //     // axios.get("/api/users/" + user_id).then((res) => {
  //     // let agency_id = user_id;
  //     let agency_id = userById.user_agency_assoc[0].agency_id;

  //     axios.get("/api/agencies/" + agency_id).then((res) => {
  //       const activeCards = [
  //         res.data.review === 1,
  //         res.data.show_lead_card_appointment_details === 1,
  //         // res.data.is_lead === 1,
  //         res.data.is_opportunity === 1,
  //       ].filter(Boolean).length;
  //       this.setState(
  //         {
  //           vonboard: res.data.vonboard,
  //           is_lead: res.data.is_lead,
  //           is_opportunity: res.data.is_opportunity,
  //           show_lead_card_appointment_details: res.data.show_lead_card_appointment_details,
  //           review: res.data.review,
  //           active: res.data.active,
  //           agency_id,
  //           agency: res.data,
  //           colSpan: activeCards > 0 ? Math.floor(24 / activeCards) : 24
  //         }, () => {
  //           setTimeout(async () => {
  //             await this.call_appointment_count();
  //             await this.loadCardData();
  //             await this.loadStats();
  //           }, 1000);
  //         }
  //       );
  //     });
  //     // });
  //   }
  // };
  // Add this lifecycle method

  // componentDidUpdate = async (prevProps, prevState) => {
  //   if (prevProps.collapsed !== this.props.collapsed) {
  //     this.setState({
  //       collapsed: this.props.collapsed,
  //     });
  //   }

  //   if (prevState.user_t !== this.state.user_t) {
  //     this.get_live_appointment_count();
  //   }

  //   if (prevState.filter_lsp !== this.state.filter_lsp || prevState.user_t !== this.state.user_t) {
  //     setTimeout(async () => {
  //       await this.loadCardData();
  //       await this.loadStats();
  //     }, 200);
  //     // await Promise.all([this.loadCardData(), this.loadStats()]);
  //   }
  // };


  //new dp
  componentDidMount = () => {
    let user_id = this.state.user.id;
    let userById = useBoundStore.getState().userById;

    const handleAgencyResponse = (res, agency_id) => {
      const activeCards = [
        res.data.review === 1,
        res.data.show_lead_card_appointment_details == 1,
        res.data.is_opportunity === 1,
      ].filter(Boolean).length;

      this.setState({
        vonboard: res.data.vonboard,
        is_lead: res.data.is_lead,
        is_opportunity: res.data.is_opportunity,
        show_lead_card_appointment_details: res.data.show_lead_card_appointment_details,
        review: res.data.review,
        active: res.data.active,
        agency_id,
        agency: res.data,
        colSpan: activeCards > 0 ? Math.floor(24 / activeCards) : 24
      });
    };

    const hasCurrentUserDetails =
      userById &&
      userById.id === user_id &&
      userById.user_agency_assoc &&
      userById.user_agency_assoc[0];

    if (!hasCurrentUserDetails) {
      axios.get("/api/users/" + user_id).then((res) => {
        useBoundStore.getState().setUserById(res.data);
        let agency_id = res.data.user_agency_assoc[0].agency_id;

        axios.get("/api/agencies/" + agency_id).then((res) => {
          handleAgencyResponse(res, agency_id);
        });
      });
    } else {
      let agency_id = userById.user_agency_assoc[0].agency_id;

      axios.get("/api/agencies/" + agency_id).then((res) => {
        handleAgencyResponse(res, agency_id);
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const currentAgencyCreated = useBoundStore.getState().AgencyInfo.created_on;

    // ✅ RUN ONLY ONCE when BOTH agency_id + created_on available
    if (
      this.state.agency_id &&
      currentAgencyCreated &&
      !this.state.isAgencyReady
    ) {
      const { start_date, end_date } = this.getDefaultDateRange();
      const isAllBfiles = useBoundStore.getState().AMDashboardFilter.isAllBfiles !== false;

      // Drop GlobalDashboard (or other role) dateObj when EA starts in All B Files mode
      if (isAllBfiles) {
        localStorage.removeItem("dateObj");
        localStorage.removeItem("dateObjRecentExtRaC");
      }

      this.setState(
        {
          agencyInfo: currentAgencyCreated,
          start_date,
          end_date,
          period: isAllBfiles ? "all_bfiles" : this.state.period,
          isAllBfiles,
          isAgencyReady: true
        },
        async () => {
          await this.call_appointment_count();
          await this.loadCardData();
          await this.loadStats();
        }
      );

      return; // ⛔ prevent extra triggers in same cycle
    }

    // existing logic 👇

    if (prevProps.collapsed !== this.props.collapsed) {
      this.setState({ collapsed: this.props.collapsed });
    }

    if (prevState.user_t !== this.state.user_t) {
      this.get_live_appointment_count();
    }

    if (
      prevState.filter_lsp !== this.state.filter_lsp ||
      prevState.user_t !== this.state.user_t
    ) {
      setTimeout(async () => {
        await this.loadCardData();
        await this.loadStats();
      }, 200);
    }
  }

  get_live_appointment_count = async () => {
    const { agency_id, isAllBfiles, start_date, end_date } = this.state;
    const myDateObj = !isAllBfiles ? localStorage.getItem("dateObj") : null;
    const parsedDateObj = myDateObj ? JSON.parse(myDateObj) : null;
    const startDate = parsedDateObj ? parsedDateObj.start_date : start_date;
    const endDate = parsedDateObj ? parsedDateObj.end_date : end_date;
    this.setState({ loadingChart: true });
    try {
      let url = GET_LIVE_APPOINTMENT + `?agency_id=${agency_id}`;
      if (this.state.user_t && this.state.user_t != 'all') {
        url += `&bfile_user_id=${this.state.user_t}`
      }
      if (!isAllBfiles && startDate && endDate) {
        url += `&start_date=${startDate}&end_date=${endDate}`
      }

      const res = await axios.get(url)
      const data = res && res.data || {};
      const bfiles_counts = {
        leads: data.prospect_appointments || 0,
        opportunity: data.followup_appointments || 0,
        review: data.review_appointments || 0
      }
      this.setState({ bfiles_counts });
    }
    catch (error) {
      console.error(error);
    }
    finally {
      this.setState({ loadingChart: false });
    }
  }

  call_appointment_count = async () => {
    const { agency_id, isAllBfiles, start_date, end_date, user_t } = this.state;
    const myDateObj = !isAllBfiles ? localStorage.getItem("dateObj") : null;
    const parsedDateObj = myDateObj ? JSON.parse(myDateObj) : null;
    const startDate = parsedDateObj ? parsedDateObj.start_date : start_date;
    const endDate = parsedDateObj ? parsedDateObj.end_date : end_date;
    this.setState({ loadingChart: true });
    let GET_LIVE_APPOINTMENT_URL = GET_LIVE_APPOINTMENT + `?agency_id=${agency_id}`;
    if (user_t && user_t != "all") {
      GET_LIVE_APPOINTMENT_URL += `&bfile_user_id=${user_t}`;
    }
    try {
      const [scheduleResponse, phoneNumberResponse, associations] =
        await Promise.allSettled(isAllBfiles === true ? [
          axios.get(GET_LIVE_APPOINTMENT_URL),
          axios.get(GET_BAD_PHONE_NUMBER_COUNT + `?agency_id=${agency_id}`),
          axios.get('/api/my_associations'),
        ] : [
          axios.get(GET_LIVE_APPOINTMENT + `?agency_id=${agency_id}&bfile_user_id=${this.state.user.id}` + `&start_date=${startDate}&end_date=${endDate}`),
          axios.get(GET_BAD_PHONE_NUMBER_COUNT + `?agency_id=${agency_id}` + `&start_date=${startDate}&end_date=${endDate}`),
          axios.get('/api/my_associations'),
        ]);

      const appointment_history_full =
        scheduleResponse.status === "fulfilled"
          ? scheduleResponse.value.data
          : {};

      const my_associations =
        associations.status === "fulfilled"
          ? associations.value.data
          : {};

      const bad_phone_number_count =
        phoneNumberResponse.status === "fulfilled"
          ? phoneNumberResponse.value.data.bad_phone_number_count
          : null;

      const bfiles_counts = appointment_history_full
        ? {
          leads: appointment_history_full.prospect_appointments || 0,
          opportunity: appointment_history_full.followup_appointments || 0,
          review: appointment_history_full.review_appointments || 0,
        }
        : {};

      let agencyStaffList = [];
      for (let x in my_associations) {
        const agency = my_associations[x];
        for (let i = 0; i < agency.length; i++) {
          const u = agency[i];
          agencyStaffList.push({
            name: u.first_name + " " + u.last_name,
            id: u.id,
            user_type: u.user_type,
          });
        }
      }

      this.setState({
        bfiles_counts,
        badPhoneNumber: bad_phone_number_count || 0,
        associations: agencyStaffList,
      });
    } catch (error) {
      console.error("Error fetching appointment or phone number data:", error);
    } finally {
      this.setState({ loadingChart: false });
    }
  };



  loadCardData = async () => {
    const { agency_id, user_t, isAllBfiles, start_date, end_date } = this.state;

    const myDateObj = !isAllBfiles ? localStorage.getItem("dateObj") : null;
    const parsedDateObj = myDateObj ? JSON.parse(myDateObj) : null;
    const startDate = parsedDateObj ? parsedDateObj.start_date : start_date;
    const endDate = parsedDateObj ? parsedDateObj.end_date : end_date;


    this.setState({ loading: true });

    let userParam = (user_t && user_t != 'all') ? `&bfile_user_id=${user_t}` : "";
    userParam = isAllBfiles !== true ? userParam + `&start_date=${startDate}&end_date=${endDate}` : userParam;

    let API_URL_CUSTOM_UPLOAD_LIVE;

    if (!parsedDateObj) {
      API_URL_CUSTOM_UPLOAD_LIVE = CUSTOMER_UPLOAD_LIVE_STAT_MONTHLY;
    } else {
      const startDate = parsedDateObj.start_date;
      const endDate = parsedDateObj.end_date;
      API_URL_CUSTOM_UPLOAD_LIVE = `${CUSTOMER_UPLOAD_LIVE_STAT_TOTAL}?start_date=${startDate}&end_date=${endDate}`;
    }



    if (user_t && user_t != "all") {
      API_URL_CUSTOM_UPLOAD_LIVE += `&bfile_user_id=${user_t}`;
    }




    try {
      const [fourCardData, activeCalls, customerUploadMonthLiveCount] = await Promise.allSettled([
        axios.get(GET_THREE_CARD_DATA + `?agency_id=${agency_id}${userParam}`),
        axios.get(GET_EA_ACTIVE_CALLS + `?agency_id=${agency_id}${userParam}`),
        axios.get(API_URL_CUSTOM_UPLOAD_LIVE)
      ]);

      const fourCardDataResult = fourCardData.status === 'fulfilled'
        ? fourCardData.value.data
        : {};

      const activeCallsResult = activeCalls.status === 'fulfilled'
        ? activeCalls.value.data
        : {};


      const customerUploadMonthLiveCountResult = customerUploadMonthLiveCount.status === 'fulfilled'
        ? customerUploadMonthLiveCount.value.data
        : {};


      const {
        customer_upload_history_literal,
        appointment_history_literal,
        not_interested_history_literal,
        non_responsive_history_literal,
      } = fourCardDataResult;

      const { active_calls_month, active_calls_full } = activeCallsResult;

      const live_monthly_CU_result = customerUploadMonthLiveCountResult;

      const categories = ["review", "lead", "opportunity"];
      const statsMap = {
        review: "Review",
        lead: "Prospect",
        opportunity: "FollowUp",
      };

      const card_data = categories.reduce((acc, category) => {
        const categoryKey = statsMap[category];
        acc[category] = {
          customer_upload_monthly: live_monthly_CU_result.customer_upload_live_literal[categoryKey][0] || 0,
          customer_upload_total: parsedDateObj
            ? live_monthly_CU_result.customer_upload_live_literal[categoryKey][0] || 0
            : customer_upload_history_literal[categoryKey][0] || 0,
          schedule_activity_monthly: appointment_history_literal[categoryKey][1] || 0,
          schedule_activity_total: appointment_history_literal[categoryKey][0] || 0,
          active_calls_monthly: active_calls_month[categoryKey] || 0,
          active_calls_total: active_calls_full[categoryKey] || 0,
          not_interested_monthly: not_interested_history_literal[categoryKey][1] || 0,
          not_interested_total: not_interested_history_literal[categoryKey][0] || 0,
          non_responsive_monthly: non_responsive_history_literal[categoryKey][1] || 0,
          non_responsive_total: non_responsive_history_literal[categoryKey][0] || 0,
        };
        return acc;
      }, {});

      // Update state with the fetched data

      this.setState((prevState) => ({
        dashboard: {
          ...prevState.dashboard,
          card_data,
        },
      }));
    } catch (error) {
      // Improved error handling with detailed logging
      console.error("Error fetching dashboard card data:", error);
    } finally {
      // Set loading to false after completion
      this.setState({ loading: false });
    }
  };


  getDefaultDateRange = () => {
    const agencyCreatedDate = useBoundStore.getState().AgencyInfo.created_on;
    const amDashboardFilterDate = useBoundStore.getState().AMDashboardFilter.datemodified;


    const hasNoStartDate = !amDashboardFilterDate || !amDashboardFilterDate.start_date;

    if (hasNoStartDate && agencyCreatedDate) {
      useBoundStore.getState().setAMDashboardFilter({
        datemodified: {
          start_date: moment(agencyCreatedDate).format("YYYY-MM-DD"),
          end_date: moment().format("YYYY-MM-DD")
        },
      });
    }

    return {
      start_date: agencyCreatedDate && moment(agencyCreatedDate).format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    };
  };


  loadStats = async () => {
    const {
      period,
      start_date,
      end_date,
      agency_id,
      user_t,
      user,
      filter_lsp,
      dashboard,
    } = this.state;
    let data = { window: period };

    if (start_date != null && end_date != null) {
      data.from = start_date;
      data.to = end_date;
    }

    if (period != null && period != "from_to") {
      const datesData = F.getServerDateByType(period);
      data.from = datesData.from;
      data.to = datesData.to;
    }

    this.setState({
      loadingStats: true,
    });

    let statsApi = null;

    let dash_Stats = {
      window: "from_to",
      from: DASH_STATS_START_DATE,
      to: DASH_STATS_END_DATE
    };


    if (user_t === "" || user_t === "all") {
      statsApi = axios.post(GET_EA_AGENCY_STATS, dash_Stats);
    } else if (user.id === parseInt(user_t, 10)) {
      statsApi = axios.post(GET_EA_STATS, dash_Stats);
    } else {
      statsApi = axios.post(GET_LSP_STATS, dash_Stats);
    }

    let calculatorResult = axios.post(
      `/api/v4.0/count_upload_history_date_range/count_completed_history?agency_id=${agency_id}${(user_t && user_t != 'all') ? `&bfile_user_id=${user_t}` : ""
      }`,
      dash_Stats
    );
    const combinedCountParams = new URLSearchParams();
    if (agency_id) combinedCountParams.set("agency_id", agency_id);
    if (user_t && user_t !== "all") combinedCountParams.set("bfile_user_id", user_t);
    const combinedCountUrl = `${COMBINED_COMPLETED_RAC_COUNT}${combinedCountParams.toString() ? `?${combinedCountParams.toString()}` : ""}`;
    const combinedRacCount = axios.post(combinedCountUrl, {
      from: dash_Stats.from,
      to: dash_Stats.to,
    });

    try {
      const [statsApiData, calculatorResultData, combinedRacCountData] = await Promise.allSettled([
        statsApi,
        calculatorResult,
        combinedRacCount,
      ]);

      const statsApiResult = statsApiData.status === 'fulfilled' ? statsApiData.value.data : {};
      const calculatorResultDataResult = calculatorResultData.status === 'fulfilled' ? calculatorResultData.value.data : {};
      const combinedRacCountResult = combinedRacCountData.status === 'fulfilled'
        ? F.get_combined_rac_count(combinedRacCountData.value)
        : 0;

      const presentKey = Object.keys(statsApiResult).find(key =>
        ["agency_stats", "stats", "lsp"].includes(key) && statsApiResult[key]
      );

      let agency_stats = {}
      switch (presentKey) {
        case "agency_stats":
          agency_stats = statsApiResult.agency_stats;
          break;
        case "stats":
          agency_stats = statsApiResult.stats;
          break;
        case "lsp":
          agency_stats = this.getCurrentUserStats(user_t, statsApiResult.lsp);
          break;
        default:
          console.log("Invalid key", presentKey);
      }

      agency_stats = {
        ...agency_stats,
        completed: calculatorResultDataResult.completed_history_by_date_range,
        customer_upload: calculatorResultDataResult.upload_history_by_date_range,
        combined_rac_files_count: combinedRacCountResult,
      };

      const updatedDashboard = {
        ...dashboard,
        stats: agency_stats,
      };

      this.setState((prevState) => ({
        ...prevState,
        dashboard: updatedDashboard,
      }));
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    } finally {
      this.setState({ loadingStats: false }); // Set loading to false after completion
    }
  };

  getCurrentUserStats = (user_t, lsp) => {
    const userStats = lsp.find((item) => item.user && item.user.id === parseInt(user_t, 10));
    return userStats && userStats.stats ? userStats.stats : {};
  }

  fetchAllBfiles = async () => {
    this.setState({ isAllBfiles: true }, async () => { // NOSONAR
      useBoundStore.getState().setAMDashboardFilter({
        isAllBfiles: true
      })
      this.refreshStats();
    })
  };



  refreshStats = () => {
    const { start_date, end_date } = this.getDefaultDateRange()

    useBoundStore.getState().setAMDashboardFilter({
      datemodified: {
        start_date: start_date,
        end_date: end_date
      },
      isDateRangeClicked: false
    });

    //commented due to new date picker implementation
    // useBoundStore.getState().setFsFilters({
    //   datemodified: {
    //     start_date: "2010-01-01",
    //     end_date: "2050-01-01"
    //   }
    // });

    //added due to new date picker implementation
    useBoundStore.getState().setFsFilters({
      datemodified: {
        start_date,
        end_date
      }
    });



    //commented due to new date picker implementation
    // let obj = {
    //   start_date: moment(("2010-01-01")).format("YYYY-MM-DD"),
    //   end_date: moment(("2050-01-01")).format("YYYY-MM-DD"),
    //   period: "from_to"
    // }


    //added due to new date picker implementation
    let obj = {
      start_date: start_date
        ? moment(start_date).format("YYYY-MM-DD")
        : moment("2010-01-01").format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      period: "from_to"
    };


    // localStorage.setItem('filter_lsp', "");
    // localStorage.setItem("dateObj", JSON.stringify(obj));
    localStorage.removeItem("dateObj")
    this.setState({
      //user_t:  undefined,
      //  filter_lsp: "",
      isAllBfiles: true, ...obj
    }, () => {
      useBoundStore.getState().setAMDashboardFilter({
        isAllBfiles: true
      });
      if (!this.state.filter_lsp) {
        localStorage.setItem('user_t', '');
        this.setState({
          user_t: ''
        });
      }
      setTimeout(async () => {
        await this.call_appointment_count();
        await this.loadCardData();
        await this.loadStats();
      }, 200);
    })
  }


  refresh = async () => {
    this.setState({ user_t: undefined });
    await this.loadCardData();
    await this.loadStats();
    await this.call_appointment_count();
  };


  render() {
    const {
      dashboard,
      associations,
      loading,
      loadingChart,
      loadingStats,
      agencyStatsLoading,
      myStatsLoading,
      lspStatsLoading,
      start_date,
      end_date,
      period,
      filter_lsp,
      collapsed,
      user_t,
    } = this.state;

    const user = this.props.auth.user;
    let user_type = user.user_type;
    if (user.user_type === "EA") user_type = "Agency Owner";
    if (user.user_type === "LSP") user_type = "Agency Member";

    const isDashboardHasData =
      dashboard.hasOwnProperty("agency_stats") &&
      dashboard.hasOwnProperty("stats");

    let date_url = "";
    if (period === "all_bfiles") {
      date_url = "?all_bfiles";
    }

    const {
      customer_uploaded,
      completed,
      saved_for_later,
      follow_up,
      total_pnc,
      // life_opportunities,
      umbrella_recommended,
      retirement_uncovered,
      total_assets_uncovered,
      combined_rac_files_count
    } = F.get_ea_stats(dashboard.stats, filter_lsp, user_t);

    let data = {
      customer_uploaded,
      completed,
      saved_for_later,
      follow_up,
      total_pnc,
      // life_opportunities,
      life_opportunities: dashboard.stats.life_opportunities || 0,
      umbrella_recommended,
      retirement_uncovered,
      total_assets_uncovered,
      combined_rac_files_count
    };

    // let bfile_status = F.get_activity_card_data(data, "", "bfile_status") || [];
    let customer_result = F.get_activity_card_data(data, "", "customer_result").sort((a, b) => a.orderIndex - b.orderIndex) || [];
    // const selectedUser = associations.find(user => user.id === parseInt(user_t, 10));
    const selectedUser =
      user_t === "all"
        ? null
        : associations.find(user => user.id === parseInt(user_t, 10));


    return (
      <div className="eaDashboard">
        {!loadingChart ? (
          <Row gutter={[8, 8]}>
            {(this.state.review === 1 || this.state.vonboard === 1
              || this.state.show_lead_card_appointment_details === 1
            ) ? (
              <React.Fragment>
                <Col span={24} md={12}>
                  <EaDashboardChart
                    props={this.props}
                    appointment_name="Appointments Scheduled"
                    state={{
                      ...this.state, type_of_call:
                        this.state.review === 1
                          ? REVIEW
                          : this.state.show_lead_card_appointment_details === 1
                            // : this.state.is_lead === 1
                            ? PROSPECT
                            : FOLLOWUP
                    }}

                    refresh={() => this.refresh()}
                    collapsed={collapsed}
                  />
                </Col>

                <Col span={24} md={12}>
                  <EaProfileFilter
                    state={{ ...this.state, user_type }}
                    collapsed={collapsed}
                    with_appointments={true}
                    setState={(e, cb) => this.setState(e, () => cb && cb())}
                    badPhoneNumberCount={this.state.badPhoneNumber}
                    unseen_notifications={this.state.unseenNotifications}
                  />
                </Col>
              </React.Fragment>
            ) : (
              <Col span={24}>
                <EaProfileFilter
                  state={{ ...this.state, user_type }}
                  collapsed={collapsed}
                  with_appointments={false}
                  setState={(e, cb) => this.setState(e, () => cb && cb())}
                  badPhoneNumberCount={this.state.badPhoneNumber}
                  unseen_notifications={this.state.unseenNotifications}
                />
              </Col>
            )}
          </Row>
        ) : (
          <div
            style={{
              background: "#FFF",
              padding: 20,
            }}
          >
            <Skeleton active />
          </div>
        )}

        {/* <Card> */}

        {(
          // this.state.filter_lsp === ""
          //  && 
          !loadingChart
        ) ? (
          <Card className="filter-card ant-card-bordered">
            <div className="filter-container">
              <div className="filter-left">
                <div
                  style={{
                    visibility: this.state.filter_lsp == "" ? "visible" : "hidden",
                  }}
                  className="marginTopResp"
                >
                  <div className="datepicker-label" style={{ paddingLeft: 35, fontWeight: '500' }}>
                    Filter by Staff</div>
                  <img src={filter} alt={"filter"} />
                  <Select
                    style={{ marginLeft: 12, width: "70%" }}
                    className="drop_down"
                    placeholder="Select Staff"
                    value={user_t && user_t !== "" ? user_t : "all"}
                    // value={user_t !== undefined ? user_t : undefined}
                    allowClear
                    onChange={(value) => {
                      let changeValue = value ? value : 'all';
                      this.setState({ user_t: changeValue });
                      if (value == 'all' || !value) {
                        this.setState({
                          user_t: ''
                        });
                        localStorage.setItem('user_t', '');
                      } else {
                        localStorage.setItem('user_t', changeValue);
                      }
                      // } else {
                      // localStorage.setItem('user_t', "all");
                      // }
                    }}
                  >
                    <Select.Option value="all">
                      All
                    </Select.Option>

                    {associations.map((e, index) => (
                      <Select.Option key={index} value={String(e.id)}>
                        {e.name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </div>

              <div className="filter-right">
                <EaDateFilter
                  vonboard={this.state.vonboard}
                  review={this.state.review}
                  is_lead={this.state.is_lead}
                  is_opportunity={this.state.is_opportunity}
                  show_lead_card_appointment_details={this.state.show_lead_card_appointment_details}
                  state={{ ...this.state }}
                  loadStats={() => Promise.resolve()}
                  loadCardData={() => this.loadCardData()}
                  call_appointment_count={() => this.call_appointment_count()}
                  refreshStats={() => this.refreshStats()}
                  fetchAllBfiles={() => this.fetchAllBfiles()}
                  setState={(e, cb) => this.setState(e, () => cb && cb())}
                />
              </div>
            </div>
          </Card>
        ) : null}


        {!loading ? (
          <Row gutter={[8, 8]} style={{ marginTop: 15 }}>
            {this.state.review === 1 && (
              <Col md={this.state.colSpan} span={24}>
                <UserActivitiesCard
                  refresh={() => this.refresh()}
                  state={{ ...this.state, type_of_call: "Review" }}
                  buttonStyle={{ background: "#57aeff" }}
                  name="Customer Uploaded"
                  appointment_name="Review Appointments Scheduled"
                  activity_name={"Review"}
                  props={this.props}
                />
              </Col>
            )}

            {this.state.show_lead_card_appointment_details === 1 && (
              /* {this.state.is_lead === 1 && ( */

              < Col md={this.state.colSpan} span={24}>
                <UserActivitiesCard
                  refresh={() => this.refresh()}
                  state={{ ...this.state, type_of_call: "Prospect" }}
                  buttonStyle={{ background: "#219d5c" }}
                  name="Customer Uploaded"
                  activity_name={"Leads"}
                  appointment_name="Lead Appointments Scheduled"
                  props={this.props}
                />
              </Col>

            )}

            {this.state.is_opportunity === 1 && (

              <Col md={this.state.colSpan} span={24}>
                <UserActivitiesCard
                  refresh={() => this.refresh()}
                  state={{ ...this.state, type_of_call: "FollowUp" }}
                  className={collapsed ? "card_collapsed" : ""}
                  buttonStyle={{ background: "#ffd427" }}
                  name="Customer Uploaded"
                  activity_name={"Opportunities"}
                  appointment_name="Opportunity Appointments Scheduled"
                  props={this.props}
                />
              </Col>

            )}
          </Row>
        ) : (
          <div
            style={{
              marginTop: 20,
              background: "#FFF",
              padding: 20,
            }}
          >
            <Skeleton active />
          </div>
        )
        }

        {/* </Card> */}

        {
          !loadingStats ? (
            <Card className="custom-card">
              <div>
                {/* <EaDateFilter
                state={{ ...this.state }}
                loadStats={() => this.loadStats()}
                setState={(e, cb) => this.setState(e, () => cb && cb())}
              /> */}
              </div>
              <div className="calculator_result">
                <div
                  className="activity_name"
                  style={{ position: "absolute", width: "95%", top: "15px" }}
                >
                  Total Intelligence Link Results
                </div>
                {/* <Row gutter={8} className="activity_name_card" style={{ marginTop: 25 }}> */}
                <div style={{
                  marginTop: 30,
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}>
                  {[
                    customer_result.slice(0, 1),
                    customer_result.slice(1, 4),
                    customer_result.slice(4),
                  ].map((cardRow, rowIndex) => (
                    <div
                      key={rowIndex}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        flexWrap: "wrap",
                      }}
                    >
                      {cardRow.map((e, index) => (
                        <Activity_card
                          key={`${rowIndex}-${index}`}
                          md={e.md}
                          link={e.link}
                          name={e.name}
                          count={e.count}
                          img={e.icon || ""}
                          index={e.index}
                          props={this.props}
                        />
                      ))}
                    </div>
                  ))}
                </div>
              </div>

              {/* <div className="calculator_result" style={{ paddingTop: 0 }}>
              <Row gutter={24} className="activity_name_card">
                {bfile_status.map((e, index) => {
                  return (
                    <Activity_card
                      key={index}
                      link={e.link}
                      img={e.icon || ""}
                      name={e.name}
                      count={e.count}
                      md={7}
                    />
                  );
                })}
              </Row>
            </div> */}
            </Card>
          ) : (
            <div
              style={{
                marginTop: 20,
                background: "#FFF",
                padding: 20,
              }}
            >
              <Skeleton active />
            </div>
          )
        }
        {/* <DownloadModal
          visible={this.state.showdownloadModal}
          setIsVisible={() => this.setState({ showdownloadModal: false })}
          agency_id={this.state.agency_id}
        /> */}
      </div >
    );
  }
}

export default EaDashboard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/EaDashboards.js